<template>
  <div>
    <div class="">
      <nav class="flex space-x-4" aria-label="Tabs">
        <span
          v-for="tab in parts"
          :key="tab.name"
          class="hover:bg-indigo-200 cursor-pointer dark:hover:bg-indigo-900"
          :class="[
            tab.id == curPartId
              ? 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900 dark:text-indigo-100'
              : 'text-gray-800 dark:text-gray-200',
            'rounded-md px-3 py-2 text-md font-bold',
          ]"
          @click="onParts(tab.id)"
          >{{ tab.name }}</span
        >
      </nav>
      <div class="border-b-2 border-gray-200 my-2"></div>
      <nav class="flex space-x-4" aria-label="Tabs">
        <span
          v-for="tab in categories"
          :key="tab.name"
          class="hover:bg-indigo-200 cursor-pointer dark:hover:bg-indigo-900"
          :class="[
            tab.id == curCategoryId
              ? 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900 dark:text-indigo-100'
              : 'text-gray-800 dark:text-gray-200',
            'rounded-md px-3 py-2 text-md font-bold',
          ]"
          @click="onCategory(tab.id)"
          >{{ tab.name }}</span
        >
      </nav>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const emit = defineEmits(["cur-part-id", "cur-category-id"]);

const parts = [
  { name: "Part1", id: 1, href: "#" },
  { name: "Part2&3", id: 2, href: "#" },
];

const categories = [
  { name: "全部", id: 0 },
  { name: "人物", id: 1 },
  { name: "事物", id: 2 },
  { name: "事件", id: 3 },
  { name: "地点", id: 4 },
];

const curPartId = ref(1);
const curCategoryId = ref(0);

const onParts = (partId: number) => {
  curPartId.value = partId;
  emit("cur-part-id", partId);
};
const onCategory = (categoryId: number) => {
  curCategoryId.value = categoryId;
  emit("cur-category-id", categoryId);
};
</script>
